import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@toothsomatics/ui/fonts.css';
import '@toothsomatics/ui/tokens.css';
import './styles/global.css';
// Buttons and shared shell styles, needed on every route rather than only the reflection flow.
import './app.css';

import { Root } from './Root.js';

/**
 * Order matters: fonts, then tokens, then the base styles that consume them, then any component
 * stylesheet imported further down the tree. Tokens must be defined before anything reads a var().
 */
const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
